import styled from '@emotion/styled';

import { shouldForwardProp } from '@hrworks/design-system/utilities';
import { Button as _Button } from '@hrworks/sui-core/Button';

import { mq } from '../../util/mediaQueries';

type StyledButtonProps = {
  $internalVariant?: 'filled' | 'subtle' | 'unstyled';
};

const Button = styled(_Button, { shouldForwardProp })<StyledButtonProps>(({ theme, $internalVariant }) => ({
  backgroundColor: theme.stellenportal?.buttonStyle?.color || theme.eclipseTier2Color.background.brand.bold.default,
  color: theme.stellenportal?.buttonStyle?.fontStyle?.color || theme.eclipseTier2Color.text.inverse,
  [mq.supportsHover]: {
    '&&:hover': {
      opacity: theme.variables.opacity.high,
    },
  },
  ...($internalVariant === 'subtle' && {
    backgroundColor: 'transparent',
    color: theme.stellenportal?.buttonStyle?.color || theme.eclipseTier2Color.background.brand.bold.default,
    [mq.supportsHover]: {
      '&&:hover': {
        opacity: 1,
        backgroundColor:
          theme.stellenportal?.buttonStyle?.color || theme.eclipseTier2Color.background.brand.bold.default,
        color: theme.stellenportal?.buttonStyle?.fontStyle?.color || theme.eclipseTier2Color.text.inverse,
      },
    },
  }),
}));

export const S = {
  Button,
} as const;
